var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-flex',{staticClass:"calendar--container"},[_c('v-date-picker',{staticClass:"calendar elevation-0",attrs:{"value":_vm.events,"multiple":"","full-width":"","no-title":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63fcb746","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/clubhouse/clubs/meet-up/clubhouse-club-meet-up-calendar.vue
// module id = null
// module chunks = 